module.exports = __webpack_public_path__ + "img/1.ac68a8e4.jpg";